import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import createSageMiddleware from 'redux-saga';

import reducers from './reducers';
import sagas from './sagas';

const loggerMiddleware = createLogger({ collapsed: true });
const sagaMiddleware = createSageMiddleware();

const store = configureStore({
	devTools: {
		features: {
			dispatch: true, // dispatch custom actions or action creators
			export: false, // export history of actions in a file
			import: 'custom', // import history of actions from a file
			jump: true, // jump back and forth (time travelling)
			lock: true, // lock/unlock dispatching actions and side effects
			pause: true, // start/pause recording of dispatched actions
			persist: false, // persist states on page reloading
			reorder: false, // drag and drop actions in the history list
			skip: true, // skip (cancel) actions
			test: false // generate tests for the selected actions
		},
		latency: 1000,
		maxAge: 20,
		name: 'Map Feature UI',
		serialize: false,
		shouldRecordChanges: true,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		stateSanitizer: (state: any) => {
			const modifiedState = {
				...state,
				mapFeatures: {
					...state.mapFeatures,
					layers: undefined,
					sources: undefined
				}
			};

			return  modifiedState;
		}
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [
					'mapFeatures/addPreviewFile',
					'mapFeatures/requestCreateLayer',
					'mapFeatures/requestUpdateLayer'
				],
				ignoredPaths: [ 'mapFeatures.previewFile.file' ]
			},
			thunk: false
		}).prepend(
			loggerMiddleware,
			sagaMiddleware
		),
	reducer: reducers
});

sagaMiddleware.run(sagas);

export type IMapFeatureUIState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
